export const STAR_CONTAINER = "STAR_CONTAINER"
export const PUBLISH_CONTAINER = "PUBLISH_CONTAINER"
export const DELETE_DATASTREAM_FROM_CONTAINER = "DELETE_DATASTREAM_FROM_CONTAINER"
